import { DataSource } from '@angular/cdk/table';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { MachineListHttpService } from '../_services';
import { CollectionViewer } from '@angular/cdk/collections';
import { catchError, finalize } from 'rxjs/operators';

export class MachineListDataSource implements DataSource<any> {
	private macListSubject = new BehaviorSubject<any[]>([]);
	private loadingSubject = new BehaviorSubject<boolean>(false);

	public loading$ = this.loadingSubject.asObservable();

	private countSubject = new BehaviorSubject<number>(0);
	public counter$ = this.countSubject.asObservable();

	empty = false;

	constructor(private http: MachineListHttpService) {}

	connect(collectionViewer: CollectionViewer): Observable<any[]> {
		return this.macListSubject.asObservable();
	}

	disconnect(collectionViewer: CollectionViewer): void {
		this.macListSubject.complete();
		this.loadingSubject.complete();
		this.countSubject.complete();
	}

	loadMachineList(qryParams: any) {
		this.empty = false;
		this.loadingSubject.next(true);

		console.log('Calling');

		this.http.getAllMachines(qryParams).pipe(
			catchError(() => of([])),
			finalize(() => {
				this.loadingSubject.next(false);
			})
		)
		.subscribe(mListData => {
			let mList = mListData.data;
			this.loadingSubject.next(false);
			if (mList.cnt === 0) {
				this.empty = true;
			}
			this.macListSubject.next(mList.payload);
			this.countSubject.next(Math.ceil(mList.cnt));
		});
	}
}
